import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { shouldShowGoodToKnowAfterAccommodationDescription } from '@/scopes/products/domain/policies/brand'
import { HeadingLabel } from '@/scopes/products/pages/components/HeadingLabel'
import { BusInfo } from '@/scopes/products/pages/components/PracticalInformation/BusInfo'
import { space } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'
import { CarRental } from './CarRental'
import { FlightInfo } from './FlightInfo'
import { GoodToKnow } from './GoodToKnow'
import { Mealplans } from './Mealplans'
import { SustainabilityCertificateInfo } from './SustainabilityCertificateInfo'

const Wrapper = styled.div``

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

export default function PracticalInformation() {
  const intl = useIntl()
  const showGoodToKnowSection = !shouldShowGoodToKnowAfterAccommodationDescription(useConfiguration('brandName'))

  return (
    <Wrapper>
      <HeadingLabel text={intl.formatMessage({ id: 'practical_info_label' })} />
      <Content>
        {showGoodToKnowSection && <GoodToKnow />}
        <Mealplans />
        <FlightInfo />
        <BusInfo />
        <SustainabilityCertificateInfo />
        <CarRental />
      </Content>
    </Wrapper>
  )
}
